import { ogImageMeta } from "@/lib/seo/og-image";
import { createFileRoute, useLoaderData } from "@tanstack/react-router";
import { LocaleLink } from "@/components/site/LocaleLink";
import { parseBlogSearch } from "@/lib/blog-search";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";
import { PostCard } from "@/components/insights/PostCard";
import { Pagination } from "@/components/insights/Pagination";
import { Reveal } from "@/components/site/Reveal";
import { listPosts, listCategories } from "@/lib/wp.functions";
import type { WpCategory, WpPost } from "@/server/wp.server";
import { Breadcrumbs } from "@/components/site/Breadcrumbs";
import { useT } from "@/lib/i18n/I18nProvider";

import { blogListSchemas } from "@/lib/seo/page-schema";
import { urlFor } from "@/lib/seo/schema";

import { BlogIndex } from "@/components/insights/BlogIndexPage";
export const Route = createFileRoute("/blog/")({
  validateSearch: (s) => parseBlogSearch(s),
  loaderDeps: ({ search }) => ({ page: search.page ?? 1, category: search.category }),
  loader: async ({ deps }) => {
    const [posts, cats] = await Promise.all([
      listPosts({ data: { page: deps.page, perPage: 12, categorySlug: deps.category } }),
      listCategories(),
    ]);
    return { posts, cats, page: deps.page, category: deps.category };
  },
  head: ({ loaderData }) => {
    const canonical = urlFor("en", "/blog");
    return {
      meta: [
        { title: "Blog - Media Intelligence Insights | Perceptica" },
        { name: "description", content: "Practical articles on media monitoring, media intelligence, media analysis and reputation analysis from the Perceptica team. Browse the latest posts." },
        { property: "og:title", content: "Blog - Media Intelligence Insights | Perceptica" },
        { property: "og:description", content: "Practical articles on media monitoring, media intelligence, media analysis and reputation analysis from the Perceptica team. Browse the latest posts." },
        { property: "og:type", content: "website" },
        { property: "og:url", content: canonical },
        ...ogImageMeta("en", "/blog"),
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Blog - Media Intelligence Insights | Perceptica" },
      { name: "twitter:description", content: "Practical articles on media monitoring, media intelligence, media analysis and reputation analysis from the Perceptica team. Browse the latest posts." },
    ],
    links: [
    ],
      scripts: blogListSchemas({
        locale: "en",
        name: "Perceptica blog",
        description: "Insights, research and analyst notes",
        posts: loaderData?.posts?.posts?.map((p) => ({
          title: p.title.rendered.replace(/<[^>]*>/g, ""),
          slug: p.slug,
          datePublished: p.date,
        })),
      }),
    };
  },
  component: BlogIndex,
});
